import { gtcDebounce } from "gtcUtils";
import { ProductFetcher, ProductFilterManager, ProductRenderer } from "converterProductDrawerClasses";

const productFetcher = new ProductFetcher();
productFetcher.initialize();

class FlexaConverterProductDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.currentRole = this.dataset.role;
    this.initializeDomElements();
    this.productRenderer = new ProductRenderer(this.domElements.productList);
    this.productFilterManager = new ProductFilterManager(this.currentRole, []);
    this.setupEventListeners();
  }

  initializeDomElements() {
    this.domElements = {
      trigger: this.querySelector("gtc-trigger[data-product-opener]"),
      productList: this.querySelector("[data-list]"),
      confirmBtn: this.querySelector(`[data-confirm="${this.currentRole}"]`),
      searchInput: this.querySelector("#product-search"),
    };
  }

  setupEventListeners() {
    document.addEventListener("collection-selected", (event) =>
      this.handleCollectionSelected(event.detail)
    );
    document.addEventListener("products-fetched", (event) => this.handleProductsFetched(event.detail));
    document.addEventListener("color-selected", (event) => this.handleColorSelected(event.detail));
    document.addEventListener("product-selected", () => this.handleProductSelected());
    document.addEventListener("filters-selected", (event) =>
      this.handleFiltersSelected(event.detail)
    );
    document.addEventListener("converter-calculated", () => this.setButtonLoading(false));

    this.domElements.confirmBtn.addEventListener("click", () => this.confirmSelection());
    this.domElements.searchInput.addEventListener(
      "input",
      gtcDebounce((event) => this.search(event.target.value))
    );

    this.domElements.productList.addEventListener("click", (event) =>
      this.handleLabelClick(event)
    );
  }

  setButtonLoading(loading) {
    this.domElements.trigger.classList.toggle("flexa-converter__selector__button--loading", loading);
    this.domElements.confirmBtn.classList.toggle("flexa-converter__selector__button--loading", loading);
  }

  handleCollectionSelected(collection) {
    this.domElements.productList.replaceChildren([]);
    this.selectedCollection = collection;
    this.domElements.trigger.setAttribute("disabled", "true");
    this.domElements.trigger.querySelector('[data-btn-text]').textContent =
      window.theme.converterStrings[this.currentRole].button;
  }

  handleProductsFetched(productElements) {
    this.productFilterManager.currentProductElements = this.productRenderer.renderProducts(
      productElements,
      this.currentRole
    );
  }

  handleColorSelected(detail) {
    if (this.currentRole === "current") {
      this.selectedColor = detail;
      this.domElements.trigger.removeAttribute("disabled");
    }
  }

  handleProductSelected() {
    this.search();
    if (this.currentRole === "upgrade") {
      this.domElements.trigger.removeAttribute("disabled");
    }
  }

  handleFiltersSelected(detail) {
    const { filterGroups, role } = detail;
    if (this.currentRole !== role) return;

    if (this.productFilterManager.currentProductElements.length) {
      this.productFilterManager.setFilters(filterGroups);
      this.search();
    }
  }

  search(input = "") {
    const matchingIds = this.productFilterManager.filterProducts(input);
    this.productFilterManager.updateProductVisibility(matchingIds);
  }

  handleLabelClick(event) {
    const label = event.target.closest("label");
    if (!label || event.target.classList.contains("flexa-converter__product__content__link")) return;

    event.preventDefault();
    const checked = !label.control.checked;
    label.control.checked = checked;
    label.control.dispatchEvent(new Event("change", { bubbles: true }));

    this.domElements.confirmBtn.disabled = !checked;
    this.selectedProductElement = label;
    this.uncheckOtherLabels(label);
  }

  uncheckOtherLabels(selectedLabel) {
    const allLabels = Array.from(this.domElements.productList.querySelectorAll("label"));
    allLabels
      .filter((label) => label !== selectedLabel)
      .forEach((label) => {
        label.control.checked = false;
        label.classList.remove("flexa-converter__product--selected");
      });
  }

  confirmSelection() {
    if (!this.selectedProductElement) return;

    const productId = this.selectedProductElement.dataset.productId;
    sessionStorage.setItem(`selected-${this.currentRole}-id`, productId);

    const hasUpgrade = sessionStorage.getItem("selected-upgrade-id");
    if ((this.currentRole === "current" && hasUpgrade) || this.currentRole === "upgrade") {
      this.setButtonLoading(true);
    }

    this.domElements.trigger.querySelector('[data-btn-text]').textContent =
      window.theme.converterStrings[this.currentRole].buttonChange;

    this.dispatchProductSelected(productId);
  }

  dispatchProductSelected(productId) {
    const detail = {
      role: this.currentRole,
      element: this.selectedProductElement,
      productId,
    };
    document.dispatchEvent(new CustomEvent("product-selected", { detail }));
  }
}

customElements.define("flexa-converter-product-drawer", FlexaConverterProductDrawer);